var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"mx-5"},[_c('h1',[_vm._v("Licencias")]),_c('LmLicenses',{attrs:{"isAdmin":"","user":_vm.$route.params.id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }